import styled from 'styled-components';

const DateText = styled.div`
  font-size: 14px;
  color: var(--grey500);
  font-weight: 500;
`;

export default DateText;
